import TpCreditMemoLineItem from '../../Domain/CreditMemo/TpCreditMemoLineItem';
import SearchParams from '../../Elements/SearchParams';
import TpCreditMemoLineSearchParams from '../../Contents/Operations/TpCreditMemo/Details/TpCreditMemoLineSearchParams';
import AuthService from '../authService';

export default class TpCreditMemoLineService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, TpCreditMemoLineSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/TpCreditMemoLine/GetListBySearching/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpCreditMemoLineItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static GetDataForCreditApply(searchItem, allItemInTheSearchSetAreSelected, selectedItems) {
    const searchParams = {
      SearchItem: searchItem,
      AllItemInTheSearchSetAreSelected: allItemInTheSearchSetAreSelected,
      SelectedItems: selectedItems.map((item) => {
        return {
          LineItemId: item.LineItemId,
          JobLineId: item.JobLineId,
          TpCreditMemoLineId: item.TpCreditMemoLineId,
        };
      }),
    };

    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/TpCreditMemoLine/GetDataForCreditApplyAsync?clearCache=true',
      JSON.stringify(searchParams)
    );
  }

  static ApplyCredit(editItem, selected, searchItem, allItemInTheSearchSetAreSelected) {
    const body = {
      EditItem: editItem,
      SearchItem: searchItem,
      AllItemInTheSearchSetAreSelected: allItemInTheSearchSetAreSelected,
      SelectedItems: selected.map((item) => {
        return {
          LineItemId: item.LineItemId,
          JobLineId: item.JobLineId,
          TpCreditMemoLineId: item.TpCreditMemoLineId,
        };
      }),
    };

    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/TpCreditMemoLine/ApplyCreditMemoLinesAsync',
      JSON.stringify(body)
    );
  }
}
